import axios from 'axios'
import config from '@/config'

const bookingService = {
  getCategoryList(context, companyId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/admin/booking/list/category?companyId=${companyId}`
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  createProduct(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + '/admin/booking/create/product',
        data: data
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  createCategory(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + '/admin/booking/create/category',
        data: data
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateCategory(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + '/admin/booking/update/category',
        data: data
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  reorderCategory(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + '/admin/booking/reorder/category',
        data: data
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteProduct(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + '/jobcode/delete/product',
        data: data
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  }
}
export default bookingService
